import { createTheming } from "@callstack/react-theme-provider";
import { themes } from "./themes";

// Initialize theming utilities with the brand default (Midnight).
const { ThemeProvider, withTheme, useTheme } = createTheming(themes.midnight);

export { ThemeProvider, withTheme, useTheme };
